import React from 'react';
import { Button, Tooltip } from 'antd';

import { REFRESH } from '../icons';
import Spinner from '../loading/Spinner';

/**
 * A view's own Refresh (KPR-1346; docs/platform-standards.md §3 "Refresh"):
 * re-read what is on screen without reloading the tab. One square icon
 * button with the REFRESH glyph, named "Refresh" for touch, screen readers
 * and the tooltip.
 *
 *   <RefreshButton pending={reloading} onRefresh={reload} />
 *
 * While `pending` the glyph becomes the small spinner (the button keeps its
 * square, keeps focus) and a press does nothing: one re-read at a time. The
 * page does not dim (§14 "Inline pending state on a control"). The 44px
 * touch floor on a phone is `.refresh-button` in items-list.css.
 */
export default function RefreshButton({ pending = false, onRefresh, disabled = false, className = '' }) {
	const handleClick = () => {
		if (pending || disabled || typeof onRefresh !== 'function') return;
		onRefresh();
	};
	return (
		<Tooltip title="Refresh">
			<Button
				className={`refresh-button${pending ? ' is-pending' : ''}${className ? ` ${className}` : ''}`}
				icon={pending ? <Spinner size="sm" label={null} /> : <REFRESH aria-hidden="true" />}
				aria-label="Refresh"
				aria-busy={pending || undefined}
				disabled={disabled}
				onClick={handleClick}
				data-testid="refresh-button"
			/>
		</Tooltip>
	);
}
